/**
 * Returns the effective price for budget/cost calculations.
 * Uses adjustedPrice when set, otherwise falls back to brand price.
 * @param {{ price?: number|string, adjustedPrice?: number|string|null }} item - Product item with price and optional adjustedPrice
 * @returns {number}
 */
export const getEffectivePrice = (item) => {
  if (!item) return 0;
  const hasAdjusted =
    item.adjustedPrice != null &&
    item.adjustedPrice !== '';
  const value = hasAdjusted
    ? Number(item.adjustedPrice)
    : Number(item.price);
  return Number.isNaN(value) ? 0 : value;
};
